/**
 * Copyright �2013 Renoworks, Inc. All rights reserved. www.Renoworks.com
 *
 * @param {jQuery} $
 *            A reference to the jQuery object.
 */
(function ($) {
  /**
     * TODO: Make this code more dynamic, consolidate the functions, addSiding,
     * addRooding, etc. into single dynamic functions, addProduct(may require,
     * addTileProduct, addGridProduct)
     */
  Renoworks = window.Renoworks || {};
  Renoworks.ProductHandler = new ProductHandler();

  var startXpath = '/product/categories/category';
  var currentProductsXpath;
  var productManager;
  var currentCategory = null;
  var productSettings = {
    Collection: null,
    Style: null,
  };
  var sideMenuItemDescriptionTemplate;
  var sideMenuItemTemplate;

  var colorPostfix = ' color';

  function ProductHandler() { }

  ProductHandler.prototype.initialize = function () {
    initializeTable();
    productManager = new ProductManager();
  };

  function initializeTable() {
    sideMenuItemDescriptionTemplate = $('#dynamic_description').html().trim();
    sideMenuItemTemplate = $('#dynamic_item').html().trim();
    $('.product_nav_buttons .prev').click(prevButtonClicked);
    $('.product_nav_buttons .next').click(nextButtonClicked);
  }

  ProductHandler.prototype.showFirstTab = function () {
    displayCategory(startXpath);
    updateNavigationButtonsStatus();
  };

  ProductHandler.prototype.resetDoorProperties = function () {
  };

  ProductHandler.prototype.selectByGridSettings = function (gridSettings) {
    productManager.selectByGridSettings(gridSettings);
  };

  ProductHandler.prototype.renderProduct = function () {
    productManager.render();
  };

  ProductHandler.prototype.propagateLayerProductOptions = function () {
    if (Renoworks.ProjectController.getRegion() != null) {
      // layer names should be unique so we only expect 1 layer
      var layer = Renoworks.ProjectController.getLayersForName(Renoworks.ProjectController.getRegion())[0];
      var data = Renoworks.ProjectController.getProductForRegion(layer.name);
      if (data != null) {
        var gridSettings = data.data.split('||')[1].split('=')[1];
        if (gridSettings != null) {
          gridSettings = gridSettings.substring(gridSettings.indexOf('=') + 1, gridSettings.length);
          productManager.selectByGridSettings(gridSettings);
        }
      }
    }
  };

  ProductHandler.prototype.setSelectedProduct = function () {
    $('#sub_header_menu ul li.selected').click();
  };

  ProductHandler.prototype.getProductSettings = function () {
    return getProductSettings();
  };

  ProductHandler.prototype.setProductForDesign = function setProductForDesign(collection, style, gridSettings) {
      var xpath = startXpath + "/category[@name='" + collection + "']/category";
      var $tabsAfterThis = $('#sub_header_menu ul li[xpath^="' + startXpath + '/category"]');
      productSettings['Collection'] = collection;
      $tabsAfterThis.not('[xpath^="' + xpath + '"]').remove();
      displayCategory(xpath);
      productSettings['Style'] = style;
      products = Renoworks.ProductController.getProducts(style);
      if (products[0]) {
        productManager.setProduct(products[0].selectByGridSettings(gridSettings));
      }

      displayProduct(ProductManager.product);
  }

  function getCategory(xpath) {
    var category = Renoworks.ProductController.getCategories()[0];
    if (!category) {
      return false;
    }
    var tmp = xpath.substring(startXpath.length).split('/category');

    for (var i = 0; i < tmp.length; i++) {
      if (tmp[i].length > 0) {
        var name = tmp[i].substring(tmp[i].indexOf('\'') + 1, tmp[i].lastIndexOf('\''));
        for (var j = 0; j < category.categories.length; j++) {
          if (category.categories[j].name == name) {
            category = category.categories[j].categories[0];
            break;
          }
        }
      }
    }
    return category;
  }

  function displayCategory(xpath) {
    removeDisclaimer();
    var category = getCategory(xpath);
    currentCategory = category.name;

    // clear all the side panel options except for the template
    $('.product_collections .grid_cell').not('.dynamic').remove();
    var title = $('.product_configurator .title');
    title.html(category.name);
    title.attr('xpath', xpath);
    if (category.categories) {
      for (var j = 0; j < category.categories.length; j++) {
        var subCategory = category.categories[j];
        var desc = subCategory.description;
        desc = desc || '';
        var isSelected = productSettings[currentCategory] == subCategory.name;
        if (subCategory.categories && subCategory.categories.length > 0) {
          addMenuItem(subCategory.name, desc, subCategory.thumbnail, isSelected, categoryItemClicked);
        } else {
          addMenuItem(subCategory.name, desc, subCategory.thumbnail, isSelected, productItemClicked);
        }
      }
      // prepare the header element
      var header = $('#sub_header_menu ul li').filter(function () {
        return $(this).text() == category.name;
      }).first();
      if (header.length == 0) {
        var header = $('<li></li>');
        header.text(category.name).attr('xpath', xpath).click(categoryTabClicked);
        header.text(category.name).click(categoryTabClicked);
        header.attr('data-label', category.name);
        // Review should be the last tab option
        $('#sub_header_menu ul li[data-label="review_doors"]').before(header);
      }
      header.attr('xpath', xpath);
      $('#sub_header_menu ul li.selected').removeClass('selected');
      header.addClass('selected');
    } else {
      // There is only one category, do the logic as if it was clicked, and don't show the header for category
      currentProductsXpath = $('.product_configurator .title').attr('xpath');
      var name = category.name;
      productManager.initialize(name);
      displayProduct(ProductManager.product);
      productSettings['Style'] = name;
      nextButtonClicked();
      // Configurator has moved to 'Model' tab, trigger a render with the first model
      $('#select_product .product_collections .grid_cell:first').click();
      removeOtherRWDs();
    }
    return true;
  }

  function displayProduct(product) {
    $('#sub_header_menu ul li[tabName]').remove();
    var tabs = productManager.getTabs();
    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      if (tab.visible) {
        // prepare the header elements
        var options = productManager.getTabOptions(tab.name);

        // Choosing whether to show the options or the colors
        //                if ((options.length == 1 && options[0].grid.colors.length > 0) // show colors if there is a single option with multiple available colors
        //                    || tab.name.toLowerCase().endsWith(' color') || tab.name.toLowerCase().endsWith(' colour')) { // show colors if tabname endsWith 'color'
        //                    prepareHeaderElement(tab.name, colorOptionTabClicked);
        //                } else {
        prepareHeaderElement(tab.name, optionTabClicked);
        if (tab.selectedGrid && tab.selectedGrid.colors) {
          var selectedOption = getColorOptionForVritualTab(tab.name + colorPostfix);
          if (selectedOption && selectedOption.grid.colors.length > 0) {
            prepareHeaderElement(tab.name + colorPostfix, virtualColorOptionTabClicked);
          }
        }
        //                }
      }
    }
  }

  function removeDisclaimer() {
    $('.product_configurator .disclaimer').remove();
  }

  // For normal tabs
  function displayOptions(tabName) {
    removeDisclaimer();

    if (tabName === 'Windows') {
      $('.product_configurator .title').after('<p class="disclaimer">Satin glass is also available</p>');
    }

    $('.product_configurator .title').html(tabName);
    $('.product_collections .grid_cell').not('.dynamic').remove();
    options = productManager.getTabOptions(tabName);

    for (var i = 0; i < options.length; i++) {
      var option = options[i];
      var name = option.name;
      var tilda = option.name.indexOf('~');
      if (tilda > 0) {
        name = option.name.substring(0, tilda);
      }
      addMenuItem(
        name,
        '',
        option.thumbImage,
        option.selected,
        optionItemClicked(tabName, option.grid.name)
      );
    }

    if (options.length == 0) {
      $('.product_collections').append('<div class="grid_cell collections">No options available</div>');
    }
  }

  // For tabs that are colors only (ie. have a grid with a list of available
  // colors)
  function displayColorOptions(tabName) {
    removeDisclaimer();
    options = productManager.getTabOptions(tabName);
    var tabText = tabName;
    var index = 0;
    if ((index = tabText.toLowerCase().indexOf('color')) != -1) {
      tabText = 'Color';
    }
    $('.product_configurator .title').html(tabText);
    $('.product_collections .grid_cell').not('.dynamic').remove();

    if (options.length == 0) {
      $('.product_collections').append('<div class="grid_cell collections">No options available</div>');
    } else {
      var colors = options[0].grid.colors;
      for (var i = 0; i < colors.length; i++) {
        var color = colors[i];

        addMenuItem(
          color.name,
          '',
          'image',
          (options[0].grid.selectedColor.guid == color.guid), // isSelected
          colorItemClicked(options[0].tab.name, color.name), // click callback
          color // tumbnail color
        );
      }
    }
  }

  function getColorOptionForVritualTab(tabName) {
    if (tabName.endsWith(colorPostfix)) {
      tabName = tabName.substring(0, tabName.lastIndexOf(colorPostfix));
      options = productManager.getTabOptions(tabName);
      for (var i = 0; i < options.length; i++) {
        if (options[i].selected && options[i].grid.colorTitle) {
          return options[i];
        }
      }
    }
  }

  // For tabs that have both options and colors we display a virtual tab for
  // the color
  function displayVirtualColorOptions(tabName) {
    removeDisclaimer();
    var tabText = tabName;
    var index = 0;
    if ((index = tabText.toLowerCase().indexOf('color')) != -1) {
      tabText = 'Color';
    }
    $('.product_configurator .title').html(tabText);
    var disclaimerText = 'Actual color may vary from swatches shown. ';
    if (productSettings.Collection !== 'Homestead' && productSettings.Collection !== 'Contemporary') {
      disclaimerText += 'Walnut &amp; Greywood available soon.';
    }
    $('.product_configurator .title').after('<p class="disclaimer">' + disclaimerText + '</p>');
    $('.product_collections .grid_cell').not('.dynamic').remove();
    if (tabName.endsWith(colorPostfix)) {
      var selectedOption = getColorOptionForVritualTab(tabName);
      if (selectedOption.grid.colors.length == 0) {
        $('.product_collections').append('<div class="grid_cell collections">No options available</div>');
      }
      for (var i = 0; i < selectedOption.grid.colors.length; i++) {
        var color = selectedOption.grid.colors[i];

        addMenuItem(color.name, '', 'image', (selectedOption.grid.selectedColor.guid == color.guid),
          colorItemClicked(selectedOption.tab.name, color.name), color);
      }
    }
  }

  function prepareHeaderElement(tabName, clickCallback) {
    var header = $('#sub_header_menu ul li[tabName="' + tabName + '"]').first();
    if (header.length == 0) {
      header = $('<li></li>');
      var tabText = tabName;
      var index = 0;
      if ((index = tabText.toLowerCase().indexOf('color')) != -1) {
        tabText = 'Color';
      }
      header.text(tabText).attr('tabName', tabName).click(clickCallback);
      header.attr('data-label', tabName);
      $('#sub_header_menu ul li[data-label="review_doors"]').before(header); // review should be the last tab option
    }
    header.attr('xpath', currentProductsXpath + '\\tabName');
  }

  function addMenuItem(name, description, image, selected, onClick, color) {
    var cellHtml;
    if (description) {
      cellHtml = sideMenuItemDescriptionTemplate;
    } else {
      cellHtml = sideMenuItemTemplate;
    }

    // Special case for colors
    if (color) {
      image = 'data/' + Renoworks.client + '/product/thumbnails/colors/' + color.name.toLowerCase() + '.jpg';
    }
    // Use the image if it exists and the rwd isn't flagged to use only swatches
    if (!color || !productManager.useColorSwatches()) {
      $.ajax({
        url: image,
        type: 'HEAD',
        success: function() {
          var $cell = $('.product_collections .grid_cell[data-label="' + name.toLowerCase() + '"]');
          $cell.find('.background .grid_swatch').css('background-color', '').css('background-image', 'url("' + image + '")');
          // Template is defaulted to grid_color, change to grid_option
          $cell.removeClass('grid_color').addClass('grid_option');
        }
      });
    }

    createMenuItemCell(cellHtml, name, description, '', selected, onClick, color);
  }

  function createMenuItemCell(cellHtml, name, description, image, selected, onClick, color){
    cellHtml = cellHtml.replace(/#TITLE#/g, name)
      .replace(/#DESCRIPTION#/g, description)
      .replace(/#IMAGE#/g, image);

    var $cell = $(cellHtml);
    if (selected) {
      $cell.addClass('selected');
    }
    if (color && !image) {
      $cell.find('.background .grid_swatch').css('background-color', '#' + color.hex);
    }
    $cell.removeClass('dynamic');
    $cell.click(function () {
      onClick($(this));
    }).show();

    $($cell).attr('data-label', name.toLowerCase());
    $('.product_collections').append($cell);
  }

  function updateNavigationButtonsStatus() {
    if ($('#sub_header_menu ul li.selected').attr('data-label').toLowerCase() == 'collection' && $('#sub_header_menu ul li[data-label="prepare"]').hasClass('disabled')) {
      $('.product_nav_buttons .prev').addClass('disabled');
    } else {
      $('.product_nav_buttons .prev').removeClass('disabled');
    }

    if ($('#sub_header_menu ul li.selected').next().hasClass('disabled')) {
      $('.product_nav_buttons .next').addClass('disabled');
    } else {
      $('.product_nav_buttons .next').removeClass('disabled');
    }
  }

  function getProductSettings() {
    var str = '';
    for (var key in productSettings) {
      str += '||' + key + '=' + productSettings[key];
    }
    return str;
  }

  // Click Events
  function categoryItemClicked($div) {
    var xpath = $('.product_configurator .title').attr('xpath');
    var name = $div.find('h4').text();
    var tabsAfterThis = $('#sub_header_menu ul li[xpath^="' + xpath + '/category"]');
    xpath += "/category[@name='" + name + "']/category";
    productSettings[currentCategory] = name;
    tabsAfterThis.not('[xpath^="' + xpath + '"]').remove();
    displayCategory(xpath);
    updateNavigationButtonsStatus();
  }

  function productItemClicked($div) {
    currentProductsXpath = $('.product_configurator .title').attr('xpath');
    var name = $div.find('h4').attr('data-label');
    productManager.initialize(name);
    displayProduct(ProductManager.product);
    productSettings[currentCategory] = name;
    nextButtonClicked();
    // Configurator has moved to 'Model' tab, trigger a render with the first model
    $('#select_product .product_collections .grid_cell:first').click();
    removeOtherRWDs();
  }

  function extractRWD(data) {
    if (data) {
      var rwd = data.split('||')[0];
      rwd = rwd.substring(rwd.indexOf('=') + 1, rwd.length);
      rwd = rwd.substring(0, rwd.lastIndexOf('_'));
      return rwd;
    }
  }

  function removeOtherRWDs() {
    var layers = Renoworks.ProjectController.getLayers();
    var region = Renoworks.ProjectController.getRegion();
    if (!region) {
      return;
    }
    var layer = Renoworks.ProjectController.getLayersForName(region)[0];
    var selectedProduct = Renoworks.ProjectController.getProductForRegion(layer.name);
    if (selectedProduct) {
      var selectedRWD = extractRWD(selectedProduct.data);
    }
    // remove product from other layers if it is from another brand/collection/series(cannot mix rwds)
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].name != layer.name) {
        var product = Renoworks.ProjectController.getProductForRegion(layers[i].name);
        if (product != null) { // product is applied to another unselected layer(s)
          var rwd = extractRWD(product.data);
          if (rwd && selectedRWD && rwd.name != selectedRWD.name) {
            // remove product for unselected layer
            layers[i].perspective.dontFill = false;
            Renoworks.ProjectController.setProductForRegion('', 'grid', layers[i].name);
            $('.project_image .masking_button.door_only[data-layer-id="' + layers[i].id + '"]').remove();
          }
        }
      }
    }
  }

  function optionItemClicked(tabName, optionName) {
    return function ($div) {
      productManager.selectOption(tabName, optionName);
      removeOtherRWDs();
      productManager.render();
      $div.siblings().removeClass('selected');
      $div.addClass('selected');
    };
  }

  function colorItemClicked(tabName, colorName) {
    return function ($div) {
      productManager.setColor(tabName, colorName);
      productManager.render();
      $div.siblings().removeClass('selected');
      $div.addClass('selected');
    };
  }

  function categoryTabClicked(event) {
    var xpath = $(this).attr('xpath');
    displayCategory(xpath);
    updateNavigationButtonsStatus();
  }

  function optionTabClicked() {
    $('#sub_header_menu ul li.selected').removeClass('selected');
    $(this).addClass('selected');
    var tabName = $(this).attr('tabName');
    displayOptions(tabName);
    updateNavigationButtonsStatus();
  }

  function colorOptionTabClicked() {
    $('#sub_header_menu ul li.selected').removeClass('selected');
    $(this).addClass('selected');
    var tabName = $(this).attr('tabName');
    displayColorOptions(tabName);
    updateNavigationButtonsStatus();
  }

  function virtualColorOptionTabClicked() {
    $('#sub_header_menu ul li.selected').removeClass('selected');
    $(this).addClass('selected');
    var tabName = $(this).attr('tabName');
    displayVirtualColorOptions(tabName);
    updateNavigationButtonsStatus();
  }

  function prevButtonClicked() {
    if (!($('#sub_header_menu ul li.selected').attr('data-label').toLowerCase() == 'brand') || ($('#sub_header_menu ul li.selected').attr('data-label').toLowerCase() == 'brand' && Renoworks.ProjectController.getTag() == 'uploaded')) {
      $('#sub_header_menu ul li.selected').prev().click();
    }
  }

  function nextButtonClicked() {
    $('#sub_header_menu ul li.selected').next().click();
  }

  // //////////////////////////////////////////////////////////
  // Product Manager
  // encapsulate multiple products and
  // provides a unifies interface to all of them
  // //////////////////////////////////////////////////////////

  function ProductManager() {
    this.product = null;
  }

  var products;
  var layerProductInfo = [];
  var currentLayerName;

  ProductManager.prototype.initialize = function (name) {
    products = Renoworks.ProductController.getProducts(name);
    this.product = products[0];

    // Clear product from layers
    var layers = getCurrentLayers();
    if (layers) {
      layers.forEach(function (layer) {
        Renoworks.ProjectController.clearProductForRegion(layer.name);
      });
    }

    // Reset grid selections
    for (var i = 0; i < products.length; i++) {
      products[i].setDefaultOptions();
    }
  };

  function getCurrentLayers() {
    var region = Renoworks.ProjectController.getRegion();
    if (region) { // layer is selected, only render the selected door
      // layer names should be unique so we only expect 1 layer
      var layers = Renoworks.ProjectController.getLayersForName(region);
    } else {
      var layers = Renoworks.ProjectController.getLayers();
    }
    return layers;
  }

  ProductManager.prototype.render = function () {
    var _this = this;
    var product = _this.product;
    var layers = getCurrentLayers();
    layers.forEach(function (layer, i) {
      $(Renoworks.Event).one(Renoworks.Event.GRID_RENDER_SUCCESS + 'preview' + i, function (e) {
        var doorImage = $('#door_only .door_image[data-id="' + layer.id + '"]');
        if (doorImage.length > 0) {
          doorImage.css('background-image', 'url("' + e.path + '")');
        } else {
          doorImage = $('<div class="door_image"></div>');
          doorImage.attr('data-id', layer.id);
          doorImage.css('background-image', 'url("' + e.path + '")').appendTo($('#door_only'));
        }

        if (!$('#door_only').hasClass('hidden')) {
          var selectedLayer = Renoworks.ProjectController.getRegion();
          if (selectedLayer && selectedLayer != layer.name) {
            doorImage.hide();
          }
        }
      });

      layer.perspective.dontFill = true;

      product = _this.getProductForLayer(layer);

      if (~product.filters.indexOf('Single')) {
        // Render correct aspect ratio -- like a square.
        // This is only used for the review page, and door preview.
        product.width = 600;
        product.height = 600;
      }
      product.render(200, 600, 600, 'preview' + i);
    });

    var prods = Renoworks.ProjectController.getProduct();
    for (var z = 0; z < prods.length; z++) {
      var grid = Renoworks.ProductController.getProductByRWD(prods[z].data.split('||')[0].split('=')[1]);
      if (grid.renderedImage) {
        grid.renderedImage = null;
      }
    }

    $('.loading_modal').show();

    $(Renoworks.Event).one(Renoworks.Event.PROJECT_IMAGE_CHANGED, function () {
      Renoworks.LayerHandler.showLayerHighlights();
      Renoworks.LayerHandler.showDoorOnlyView();
    });
    Renoworks.ProjectController.render();
  };

  ProductManager.prototype.setColor = function (tabName, colorName) {
    var product = this.product;
    var layers = getCurrentLayers();
    for (var i = 0; i < layers.length; i++) {
      product = this.getProductForLayer(layers[i]);
      var options = product.getTabOptions(tabName);
      if (options.length == 1) {
        // For tabs with single option, the option might not be selected
        var colorObj = $.grep(options[0].grid.colors, function (c) {
          return c.name == colorName;
        })[0];
      } else {
        for (var j = 0; j < options.length; j++) {
          if (options[j].selected) {
            var colorObj = $.grep(options[j].grid.colors, function (c) {
              return c.name == colorName;
            })[0];
          }
        }
      }

      if (colorObj) {
        product.setColor(tabName, colorObj);
        Renoworks.ProjectController.setProductForRegion(
          'rwd=' + product.rwd
                    + '||gridSettings=' + product.getGridSettings()
                    + getProductSettings(), 'grid', layers[i].name);
      }
    }
  };

  ProductManager.prototype.selectOption = function (tabName, optionName) {
    var product = this.product;
    var layers = getCurrentLayers();
    for (var i = 0; i < layers.length; i++) {
      product = this.getProductForLayer(layers[i]);
      var options = product.getTabOptions(tabName);
      var option = $.grep(options, function (o) {
        return o.name == optionName;
      })[0];
      if (option) {
        product.selectGrid(option.tab, option.grid);
        Renoworks.ProjectController.setProductForRegion(
          'rwd=' + product.rwd
                    + '||gridSettings=' + product.getGridSettings()
                    + getProductSettings(), 'grid', layers[i].name);
      }
    }
  };

  ProductManager.prototype.getTabOptions = function (tabName) {
    // Returning the options of the first product that is selected
    // This might later change to returning the intersection or union of the options
    // - Nader 12/16/2016
    var layers = getCurrentLayers();
    var p;
    for (var i = 0; i < layers.length; i++) {
      p = this.getProductForLayer(layers[i]);
    }

    if (!p) {
      p = this.product;
    }

    return p.getTabOptions(tabName);
  };

  ProductManager.prototype.getTabs = function () {
    var layers = getCurrentLayers();

    // Returning the tabs of the first product that is selected
    // Assumption here is that all products have same tabs
    // This might later change to returning the intersection of the tabs
    // - Nader 12/16/2016
    var p;
    for (var i = 0; i < layers.length; i++) {
      p = this.getProductForLayer(layers[i]);
      break;
    }

    if (!p) {
      p = this.product;
    }

    return p.tabs;
  };

  ProductManager.prototype.selectByGridSettings = function (gridSettings) {
    return this.product.selectByGridSettings(gridSettings);
  };

  ProductManager.prototype.useColorSwatches = function () {
      return this.product ? this.product.useSwatches : false;
  }

  ProductManager.prototype.getProductForLayer = function (layer) {
    if (currentLayerName == layer.name) {
      return this.product;
    }
    if (layer.productFilter == 'Single Door') {
      this.product = getSubProduct('single');
    } else if (layer.productFilter == 'Double Door') {
      this.product = getSubProduct('double');
    }

    var productData = Renoworks.ProjectController.getProductForRegion(layer.name);
    if (productData && productData.data) {
      var gridSettings = productData.data.split('||')[1].split('=')[1];
      if (gridSettings != null) {
        gridSettings = gridSettings.substring(gridSettings.indexOf('=') + 1, gridSettings.length);
        this.product.selectByGridSettings(gridSettings);
      }
    }
    return this.product;
  };

  ProductManager.prototype.setProduct = function setProduct(p) {
    this.product = p;
  }

  function getSubProduct(filter) {
    for (var i = 0; i < products.length; i++) {
      if (products[i].rwd.toLowerCase().indexOf(filter) != -1) {
        return products[i];
      }
    }
  }
}(jQuery));
